import React from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import logo from '../header/images/logo.png';
import './menuoff.css';

const MenuOff = () => {
  const location = useLocation();
  const normalizedPath = String(location.pathname || '').toLowerCase();
  const showHomeMobileButton =
    normalizedPath === '/registrer' ||
    normalizedPath === '/login' ||
    normalizedPath === '/emailconnect' ||
    normalizedPath === '/forgot-password';

  return (
    <header className="menuoff">
      <div className="menuoff__logo">
        <Link to="/">
          <img src={logo} alt="ContaLearn" className="menuoff__logo-img" />
        </Link>
      </div>

      <nav className="menuoff__links" aria-label="Primary">
        <NavLink to="/login" className="none-decoration">
          <div className="menuoff__conectare">
            <span className="color-menu-off">Conecteaza-te</span>
          </div>
        </NavLink>

        <NavLink to="/quiz-start" className="none-decoration">
          <div className="create-cont">
            <span className="color-menu-off">Creeaza cont</span>
          </div>
        </NavLink>
      </nav>

      <div className="menuoff__mobile-start">
        <NavLink to={showHomeMobileButton ? '/' : '/quiz-start'} className="none-decoration">
          <div className="menuoff__starty">
            <span>{showHomeMobileButton ? 'Home' : 'start'}</span>
          </div>
        </NavLink>
      </div>
    </header>
  );
};

export default MenuOff;
